
import { Component, Vue } from 'vue-property-decorator'
import { NavBar, TaskCard, CreateHotTaskModal } from '@/components'
import FetchWrapper from '@/classes/fetchWrapper'
import store from '../store'

@Component({
  components: {
    NavBar,
    TaskCard,
    CreateHotTaskModal
  }
})
export default class TasksView extends Vue {
  data () {
    return {
      activeTab: 1,
      isLoading: false,
      loggedUserId: null,
      upcomingTasks: [],
      upcomingSearch: '',
      lastTasks: [],
      lastSearch: '',
      isNewHotTaskModalOpen: false,
      taskTypes: []
    }
  }

  mounted () {
    this.loggedUserId = store.getters.getLoggedUserId
    this.getTaskTypes()
    this.getUpcomingTasks()
    this.getLastTasks()
  }

  get isLoggedIn () {
    return this.$store.state.loggedIn
  }

  async searchUpcomingTasks () {
    await this.getUpcomingTasks()
  }

  clearSearchUpcomingTasks () {
    this.upcomingSearch = ''
  }

  async getUpcomingTasks () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getUpcomingTasks/${this.upcomingSearch}`))
      resp.map((item) => {
        item.due = new Date(item.due)
        return 0
      })
      this.upcomingTasks = resp
      this.isLoading = false
    } catch (e) {
      this.upcomingTasks = []
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get upcoming tasks.',
        canCancel: false
      })
    }
  }

  async searchLastTasks () {
    await this.getLastTasks()
  }

  clearSearchLastTasks () {
    this.lastSearch = ''
  }

  async getLastTasks () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getLastTasks/${this.lastSearch}`))
      resp.map((item) => {
        item.due = new Date(item.due)
        return 0
      })
      this.lastTasks = resp
      this.isLoading = false
    } catch (e) {
      this.lastTasks = []
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get last tasks.',
        canCancel: false
      })
    }
  }

  async openNewHotTaskModal () {
    this.isNewHotTaskModalOpen = true
  }

  async createdNewHotTask () {
    this.getUpcomingTasks()
  }

  async getTaskTypes () {
    this.isLoading = true
    try {
      this.taskTypes = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getTaskTypes`))
      this.isLoading = false
    } catch (e) {
      this.taskTypes = []
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get task types.',
        canCancel: false
      })
    }
  }
}
